import { ref, onMounted, onUnmounted } from "vue";

export function useVideoLoader(videoRef, options = {}) {
  const { rootMargin = "200px", threshold = 0.1 } = options;
  const isVisible = ref(false);
  const isLoaded = ref(false);
  let observer = null;

  const handleIntersect = (entries) => {
    const entry = entries[0];
    isVisible.value = entry.isIntersecting;

    if (!videoRef.value) return;

    if (entry.isIntersecting) {
      if (!isLoaded.value) {
        videoRef.value.load();
        isLoaded.value = true;
      }
      videoRef.value.play().catch(() => {});
    } else {
      videoRef.value.pause();
    }
  };

  onMounted(() => {
    if (!videoRef.value) return;

    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReduced) {
      videoRef.value.pause();
      return;
    }

    observer = new IntersectionObserver(handleIntersect, {
      rootMargin,
      threshold,
    });
    observer.observe(videoRef.value);
  });

  onUnmounted(() => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  });

  return { isVisible, isLoaded };
}
